import { useState } from 'react';
import { Svg } from '../../common/Svg';

export default function ImpactCard({impactData, showPhotos, campaignId}) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [image, setImage] = useState(null);
    const PROJECT_PHOTO_ALT = "Project photo";
    const highlightSelected = (event) => {
        const allThumbnails = document.querySelectorAll(".thumbnail");
        allThumbnails.forEach((thumbnail) => thumbnail.classList.remove("selected"));

        event.target.classList.add("selected");
    };

    function buildImpactCards() {
        return(

            <div>
                <div className="campaign-page-impact-letters-inside-container">
                    <div className="impact-letters-button-container">
                        <div className="dot-pagination">
                            {impactData.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => setCurrentIndex(index)}
                                    className={`dot ${index === currentIndex ? 'active' : ''}`}
                                    aria-label={`Go to item ${index + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                    <div className="impact-container">
                        <div className="impact-letter-container">
                            <div>
                                <div className="teacher-info-container">
                                    <div className="teacher-img">
                                        <img src={impactData[currentIndex].teacherPhoto} alt={PROJECT_PHOTO_ALT}/>
                                    </div>
                                    <div className="teacher-info">
                                        <p className="teacher-name">From {impactData[currentIndex].teacherName}</p>
                                        <p className="school-info"><a href={baseFrontURL + 'project/' + impactData[currentIndex].proposalId}
                                            target="_blank">{impactData[currentIndex].title}</a></p>
                                        <p className="school-info">{impactData[currentIndex].schoolName}</p>
                                        <p className="school-info">{impactData[currentIndex].city}, {impactData[currentIndex].state}</p>
                                    </div>
                                </div>
                                <div className="impact-letter">
                                    <p>"{impactData[currentIndex].impactNote}"</p>
                                </div>
                            </div>
                        </div>

                        {showPhotos && imagesPresent(impactData[currentIndex]) ?

                            <div className="impact-photos-container">

                                <div>
                                    {showImages(impactData[currentIndex].photopaths)}
                                </div>


                                <p>Photos from {impactData[currentIndex].teacherPossessiveName} project: <a
                                    href={baseFrontURL + 'project/' + impactData[currentIndex].proposalId}
                                    target="_blank">{impactData[currentIndex].title}</a></p>

                            </div>
                            : null
                        }
                    </div>



                </div>



                {showPhotos ?
                    <div className="disclaimer">
                        <p>
                            <strong>A note on content sharing:</strong> Images that contain faces of children as
                            depicted in the photos on this page are available to view on this page only, and those
                            images should not be downloaded or used for any purpose. Images of adult teachers may be
                            used for commercial and non-commercial purposes in accordance with the DonorsChoose <a
                            className="muted" href="/privacy-policy" target="_blank">Privacy Policy</a>.
                        </p>
                        <br/>
                        <p>
                            <strong>To share your support with external audiences, <a target="_blank" href={baseFrontURL + 'partner/campaign.html?id=' + campaignId}>use this
                                version</a>.</strong>
                        </p>

                    </div> : null}


            </div>

        )
    }

    function imagesPresent (data) {
        return (data.photopaths != null && data.photopaths.length > 0);
    }

    function showImages (photopaths) {
        return (
            <div className="impact-photos">
                {photopaths.map((photo, index) => {
                    return index <= 3 ? (
                        <div className="photo-frame">

                            <div className="photo-main">
                                <img
                                    src={photo}
                                    alt={PROJECT_PHOTO_ALT}
                                    className="thumbnail"
                                    onClick={(event) => {
                                        setImage(photo);
                                        highlightSelected(event);
                                    }}
                                />
                            </div>

                        </div>
                    ) : null;
                })}
            </div>
        )
    }

    function showPrevious () {
        setCurrentIndex(index => {
            if (index === 0) return impactData.length - 1;
            return index - 1;
        });
    }

    function showNext () {
        setCurrentIndex(index => {
            if (index === impactData.length - 1) return 0;
            return index + 1;
        });
    }

    function imagePopup() {
        return (
            <div>
                {image == null ? null :
                    <div className={'impact-letters-popup'}>
                        <div className="bkg-close" onClick={() => setImage(null)}></div>

                        <div className="impact-letters-popup-inside-container">
                            <img className="main" src={image} alt={PROJECT_PHOTO_ALT}/>

                            <div className="thumbnail-parent-container">
                                {impactData[currentIndex].photopaths.map(photo => (
                                    <div className="thumbnail-container">
                                        <img
                                            className="thumbnail"
                                            src={photo}
                                            alt={PROJECT_PHOTO_ALT}
                                            onClick={() => {
                                                setImage(photo);
                                                highlightSelected(event);
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>

                            <button onClick={() => setImage(null)}><Svg icon="delete"/></button>
                            <div className="disclaimer">
                                <p>
                                    <strong>A note on content sharing:</strong> Images that contain faces of children as
                                    depicted in the photos on this page are available to view on this page only, and those
                                    images should not be downloaded or used for any purpose. Images of adult teachers may be
                                    used for commercial and non-commercial purposes in accordance with the DonorsChoose <a
                                        className="muted" href="/privacy-policy" target="_blank">Privacy Policy</a>.
                                </p>
                            </div>
                        </div>
                    </div>

                }
            </div>

        )
    }

    return (
        <section id="impact-letters" className="campaign-page-impact-letters-container">
            <h2>Notes from the classroom</h2>

            {buildImpactCards()}

            {showPhotos ? imagePopup() : null}


        </section>
    )
}
